import { EXPONDO_SKU_LENGTH, EXPONDO_SKU_PREFIX } from '~~/constants/products';

export const validateExpondoStandardProductSKU = (sku: string) => {

  return sku.startsWith(EXPONDO_SKU_PREFIX) && sku.length === EXPONDO_SKU_LENGTH;

};
